var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-backdrop left-0 modal fade",
      attrs: {
        id: "go-modal-login-move",
        tabindex: "-1",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          class: [
            "modal-dialog go-modal-promotion ",
            _vm.userState === _vm.STATE.INVITE_SUCCESS ? "" : "free-pro",
          ],
        },
        [
          _vm.userState === _vm.STATE.EXIST_USER
            ? _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", { staticClass: "free-pro-top-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("payment.promotion.noticeFree.freePro"))
                    ),
                    _c("br"),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("payment.promotion.noticeFree.freePro2")
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-period-use" }, [
                    _c("em", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("payment.common.period") +
                            ": " +
                            _vm.trialPeriod
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-message-info" }, [
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("payment.promotion.noticeFree.message1")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("payment.promotion.noticeFree.message2")
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-button" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-primary",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.routeToBenefit },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("payment.button.viewMemberBenefit")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("div", { staticClass: "go-block-between" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "custom-control custom-checkbox custom-control-inline",
                        attrs: { "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            return _vm.dontShowAgain(_vm.STATE.EXIST_USER)
                          },
                        },
                      },
                      [
                        _c("input", {
                          staticClass: "custom-control-input",
                          attrs: {
                            type: "checkbox",
                            id: "customCheckDisabled1",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "custom-control-label",
                            attrs: { for: "customCheckDisabled1" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("payment.button.dont-show-again"))
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-feedback-help" }, [
                      _c("a", { attrs: { "data-dismiss": "modal" } }, [
                        _vm._v(_vm._s(_vm.$t("button.close"))),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm.userState === _vm.STATE.PRO_END
            ? _c("div", { staticClass: "modal-content" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", {
                    staticClass: "free-pro-top-title",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("payment.promotion.noticeEndPro.title")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-period-use" }, [
                    _c("strong", [_vm._v("D-" + _vm._s(_vm.trialDayRemain))]),
                    _vm._v(" "),
                    _c("em", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("payment.common.trialPeriod") +
                            ": " +
                            _vm.trialPeriod
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-message-info" }, [
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "payment.promotion.noticeEndPro.message1-1"
                              )
                            ) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "payment.promotion.noticeEndPro.message1-2"
                              )
                            ) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-button" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.routeToBenefit },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("payment.button.viewMemberBenefit")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-primary",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.routeToBenefit },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("payment.button.subscribe")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-message-benefit" }, [
                    _c("strong", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("payment.promotion.noticeEndPro.message2")
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("payment.promotion.noticeEndPro.message3")
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("div", { staticClass: "go-block-between" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "custom-control custom-checkbox custom-control-inline",
                        attrs: { "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            return _vm.dontShowAgain(_vm.STATE.PRO_END)
                          },
                        },
                      },
                      [
                        _c("input", {
                          staticClass: "custom-control-input",
                          attrs: {
                            type: "checkbox",
                            id: "customCheckDisabled1",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "custom-control-label",
                            attrs: { for: "customCheckDisabled1" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("payment.button.dont-show-again"))
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-feedback-help" }, [
                      _c("a", { attrs: { "data-dismiss": "modal" } }, [
                        _vm._v(_vm._s(_vm.$t("button.close"))),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm.userState === _vm.STATE.INVITE_SUCCESS
            ? _c("div", { staticClass: "modal-content" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("payment.promotion.noticeInviteFriend.notice", {
                          lastInvitee: _vm.lastInvitee,
                        })
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "lead",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("payment.promotion.noticeInviteFriend.title")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-period-use" }, [
                    _c("em", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("payment.common.period") +
                            ": " +
                            _vm.trialPeriod
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.routeToMyPage },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("payment.button.ok")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-primary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.routeToBenefit },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("payment.button.viewMemberBenefit")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm.userState === _vm.STATE.NEW_USER
            ? _c("div", { staticClass: "modal-content" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", {
                    staticClass: "free-pro-top-title",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("payment.promotion.noticeNewUser.title")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-period-use" }, [
                    _c("em", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("payment.common.period") +
                            ": " +
                            _vm.trialPeriod
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-message-info" }, [
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("payment.promotion.noticeNewUser.message1")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("payment.promotion.noticeNewUser.message2")
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "free-pro-button" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-primary",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.routeToBenefit },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("payment.button.viewMemberBenefit")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("div", { staticClass: "go-block-between" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "custom-control custom-checkbox custom-control-inline",
                        attrs: { "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            return _vm.dontShowAgain(_vm.STATE.NEW_USER)
                          },
                        },
                      },
                      [
                        _c("input", {
                          staticClass: "custom-control-input",
                          attrs: {
                            type: "checkbox",
                            id: "customCheckDisabled1",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "custom-control-label",
                            attrs: { for: "customCheckDisabled1" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("payment.button.dont-show-again"))
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-feedback-help" }, [
                      _c("a", { attrs: { "data-dismiss": "modal" } }, [
                        _vm._v(_vm._s(_vm.$t("button.close"))),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "modal-title" }, [_vm._v("PROMOTION")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn go-btn-icon close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "modal-title" }, [_vm._v("PROMOTION")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn go-btn-icon close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "btn go-btn-icon close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "modal-title" }, [_vm._v("PROMOTION")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn go-btn-icon close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }